import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  contentRoot: {
    padding: 0,
    minHeight: "300px",
    maxHeight: "500px",
  },
  viewBtn: {
    width: "10%",
  },
  viewBtnPlaceholder: {
    width: "10%",
    minWidth: "64px",
  },
  truncatable: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dialogMinHeight: {
    maxWidth: "800px",
  },
}))

export default styles
